import types from './types';

const getCasNumberList = () => ({
  type: types.GET_CAS_NUMBER_LIST
});

export default {
  getCasNumberList
};
